export class AssessmentModalConstants {
  static readonly MODAL_INDICATE = {
    ASSESSMENT_MODAL: 'assessment-modal',
    SUMMARY_MODAL: 'summary-modal',
  };
}
